import * as Models from "../Models";
import * as Common from "../Common/modules";

    export interface IAuthApiClient {
        getUserEmailsByPartner: (partner: Models.PartnerModel.IPartnerModel) => ng.IPromise<string[]>;
    }

    export class AuthApiClient implements IAuthApiClient {

        private prefix: string;

        public static $inject = ['igs.apiClientService'];
        constructor(private apiClient: Common.ApiClientService.Igs.Common.IApiClientService) {
            this.prefix = "authentication";
        }

        public getUserEmailsByPartner = (partner: Models.PartnerModel.IPartnerModel): ng.IPromise<string[]> => {
            return this.apiClient.post(this.prefix + '/GetUserEmailsByPartner', partner);
        }
    }
